module.exports = __webpack_public_path__ + "img/i5.27c2997d.svg";